import AircraftToSaleCard from './AircraftToSaleCard';
export default AircraftToSaleCard;
